import script from "./StudentMediaViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentMediaViewer.vue?vue&type=script&setup=true&lang=js"

import "./StudentMediaViewer.vue?vue&type=style&index=0&id=5968c135&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5968c135"]])

export default __exports__